/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxCardTransactionGetCardTransactionsByCardIdStatus = typeof UtxCardTransactionGetCardTransactionsByCardIdStatus[keyof typeof UtxCardTransactionGetCardTransactionsByCardIdStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxCardTransactionGetCardTransactionsByCardIdStatus = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  VOID: 'VOID',
  DECLINED: 'DECLINED',
} as const;
